export default __webpack_public_path__ + "static/media/bg-4.4e6a3ef2.png";